// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgSidebarExplore = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 3V1.72l-1.242.31L6.514 5.84A2 2 0 0 0 5 7.78v5.94a2 2 0 0 0 2.485 1.94l1.772-.443c.136.307.323.587.55.83l-2.664 4.438-.515.858 1.715 1.029.514-.857 2.726-4.544a3.029 3.029 0 0 0 .834 0l2.726 4.544.514.857 1.715-1.029-.514-.858-2.664-4.439a2.99 2.99 0 0 0 .798-2.263l6.493-1.623A2 2 0 0 0 23 10.22V3Zm-8.831 8.927L17 11.22V5.28L7 7.78v5.94l2.11-.528a3.001 3.001 0 0 1 5.059-1.265Zm6.511-7.443.32-.059v5.794l-2 .5V4.791l1.68-.307ZM3 8.78v5.938l-2 .5V9.281l2-.5ZM11 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
      fill="#F4F6F8"
    />
  </svg>
))
SvgSidebarExplore.displayName = 'SvgSidebarExplore'
const Memo = memo(SvgSidebarExplore)
export { Memo as SvgSidebarExplore }
